/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var _get = require('lodash.get');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var DepSEGFormView = require('./DepSEGFormView');
var SubmitSEG = require('../services/SubmitSEG');

var tmplDepSEGNewView = require('../templates/DepSEGNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepSEGNewView,

  className: 'dep-new-seg-view container-fluid',

  ui: {
    breadCrumbContainer: '.breadcrumb-container',
    segFormContainer: '.seg-form-container',
    submitButton: '.btn-submit'
  },

  regions: {
    breadCrumbContainer: '@ui.breadCrumbContainer',
    segFormContainer: '@ui.segFormContainer'
  },

  events: {
    'click @ui.categoryDropdown': 'onChangeCategory',
    'click @ui.submitButton': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = _get(this.model.get('entityIdentifiers'), 'entityName');

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#dep/dashboard'
          },
          {
            text: entityName,
            link: '#dep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'New SEG'
          }
        ]
      })
    );

    this.segForm = new DepSEGFormView({
      model: this.model
    });

    this.showChildView('segFormContainer', this.segForm);
  },

  onClickSubmit: function(event) {
    event.preventDefault();
    var self = this;
    this.validate().done(function() {
      var laddaContext = Ladda.create(self.ui.submitButton.get(0));
      laddaContext.start();

      var formData = self.getFormData();
      formData.isDeleted = 0;
      SubmitSEG(formData)
        .done(function(response) {
          Radio.channel('navigate').trigger('show:int:dp:entity:seg', formData.entityId, response.segId);
        })
        .fail(function(err) {
          laddaContext.stop();
        });
    });
  },

  validate: function() {
    return this.ui.segFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.segForm.getFormData();
  }
});
